import * as actionTypes from './actionTypes';
import { TypePublicationModel } from '@app/src/views/StepTwo/channelPublication/models/typePublication';

interface State {
  data: TypePublicationModel[];
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false
}

export const typePublication = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_TYPE_PUBLICATION_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_TYPE_PUBLICATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_TYPE_PUBLICATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
